var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _get from 'lodash/get';
export var getImagesArray = function (activeDevice) {
    var _a;
    var deviceImages = [];
    if (activeDevice.deviceImages)
        deviceImages = (_a = activeDevice.deviceImages) === null || _a === void 0 ? void 0 : _a.map(function (image) { return image.image; });
    var imagesArray = activeDevice.deviceImages
        ? __spreadArray([activeDevice === null || activeDevice === void 0 ? void 0 : activeDevice.image], deviceImages, true) : [activeDevice === null || activeDevice === void 0 ? void 0 : activeDevice.image];
    return imagesArray.filter(function (x) { return x; });
};
export var buildThumbnails = function (images) {
    return images.length > 1
        ? images.map(function (image) {
            var altText = _get(image, 'altText', '');
            var description = _get(image, 'description', '');
            return {
                src: image.url,
                accessibilityLabel: description !== null && description !== void 0 ? description : altText,
                alt: description !== null && description !== void 0 ? description : altText
            };
        })
        : null;
};
